import _enLocale from 'element-ui/lib/locale/lang/en'
export default {
	common: {
		loading: 'loading...',
		noMore: 'No More data',
		documentTitle: "Dailyedu - for Student",
		confirm: "Confirm",
		cancel: "Cancel",
		cancelApp: "Cancel the appointment",
		changetime: 'Change time',
		save: "Save",
		login: "Log in",
		submit: "Submit",
		nodata: "Data not available",
		noTime: "No available time slots",
		noNotice: "No notice",
		noAnnouncement: "no announcement", //  todo
		return: "Return",
		logout: "Log out",
		giveup: ", Quit",
		iSee: "OK",
		refreshSuc: "Refreshed",
		clearSuc: "Cleared",
		settingSuc: "Setting complete",
		saveSuccess: "Saved",
		cancelSuc: "Canceled",
		finish: "Done",
		other: "Others",
		index: "Daily Edu.",
		titleTips: "Tips",
		all: "Unread",
		nothing: "no score",
		copySuccess: "Copy Success",
		copyFailed: "Replication Failed",
		daienEducation: "Dailyedu",
		and: ",",
		ended: ".",
		dollar: "yuan",
		download: "Download",
		goConfirm: "Go Confirm",
		jxjcancel: "The appointment has been cancelled and the scholarship used has been returned to the account",
		userName: 'Please enter your name'
	},
	myJoin: {
		myJoin: 'My Contest',
		competitionTime: 'Contest time:',
		myExam: "Exam",
	},
	competition: {
		competitionName: "Name of competition",
		competitionRank: "Contest ranking",
		competitionDetail: "Contest details",
		competitionAward: "Contest winners",
		showScore: 'Share your scores',
		showOff: "Show off a little",
		rankLevel: "Ranking list",
		myRank: "My ranking",
		yourRank: "Your ranking",
		noRank: "Ranking unavailable",
		academicRank: "Top ranking students",
		pkAcademicRank: "Team Ranking",
		praise: "Like",
		getPraised: "You have received",
		praiseNum: "likes",
		qrcodeTip1: "Take on the challenge!",
		qrcodeTip2: "Long press the QR code to follow the official account",
		qrcodeTip3: "Scanning two-dimensional code sharing or",
		authorities: "Issuing agency: ",
		issuanceTime: "Time of issuance: ",
		awardTip1: "Congratulations on your outstanding performance in",
		pkAwardTip0: "Congratulations",
		pkAwradTip1: "team, on your outstanding performance in",
		awardTip2: " ",
		awardTip3: "Award",
		awardTip4: "Prize",
		awardTip: "You are issued this certificate as an encouragement!",
		win: "Win",
		iam: "I am",
		rank: "Ranking",
		stuNickName: "Student nickname",
		copyLink: "Copy links",
		rewardReault: "Winning results of the competition",
		teamRank: "Team Ranking",
	},
	competitionSeries: {
		subordinate: "Subordinate series: ",
		competitionSeries: "Contest Series",
		showMore: "Expand",
		status1: "Unstarted",
		status2: "In progress",
		status3: "Finished",
		number: " People attending",
	},
	competitionInfo: {
		detail: 'Contest details',
		title: 'Contest Name:',
		startTime: 'Contest time:',
		number: 'Participants:',
		people: '',
		scholarship: 'bonuses',
		intro: 'Contest Info:',
		content: 'Rubric:',
		studyNumber: 'Number of self-study tasks',
		lessonNum: 'Number of classes taken',
		homeworkNum: 'Number of assignments',
		studyALL: 'Self-study total',
		homeworkScore: 'Assignment total',
		awardSetting: 'Award settings',
		teamNum: "Participating team：",
		teamNum2: "Participating team",
		teamName0: "Team",
		teamName1: "name",
	},
	courseWares: {
		print: 'Print',
	},
	login: {
		testingEnvironment: "Test mode",
		switchToFormalEnvironment: "Switch to normal mode",
		switchToTestEnvironment: "Switch to test mode",
		pleaseInputEmail: "Please enter email",
		pleaseInputRightEmail: "Please enter the correct email",
		pleaseInputPassword: "Please enter password",
		mobileLogin: "Mobile log in",
		forgetPassword: "Forgot password",
		pleaseInputMobile: "Please enter phone number ",
		pleaseInputRightMobile: "Please enter the correct phone number",
		pleaseInputCode: "Please enter verification code",
		clickToGet: "SEND",
		resendCode: "",
		retransmission: " s",
		emailLogin: "Log in with email address",
		codeIsError: "Invalid code",
		codeIsInvalid: "Code has expired",
		selectEmailLogin: "Select mailbox login",
		emailName: "Email name",
		selectEmail: "Please select email",
		tip1: 'Please read and consent to',
		tip2: '"Daily Service Agreeent"',
		tip3: 'and',
		tip4: '"Privacy Protection Policy"',
		tip5: 'Please read and consent to "Daily Service Agreeent" and "Privacy Protection Policy"',
		tip6: 'More personalized content will be recommended to you after authorization. Please authorize with your Wechat.',
		tip7: 'Link to your phone number',
		tip8: 'Login with your phone number after linking. ',
		tg: 'Skip'
	},
	resetPassword: {
		identityVerification: "Identity verification",
		nextStep: "Next",
		Confirm: 'Confirm',
	},
	setPassword: {
		resetPassword: "Reset password",
		inputNewPassword: "Enter new password",
		pleaseConfirmNewPassword: "Please confirm new password",
		pleaseInputLetterNumber: "Please enter 6-20 characters, numbers, and/or symbols.",
		twoInputAtypism: "Two passwords do not match",
		passwordEditSuccess: "Password has been changed",
	},
	follow: {
		feedBack: "Follow up",
		notCompletedFeedback: "You haven’t completed feedback form.",
		followQuestion: "Follow up questions",
		confirmCancelFollow: "Are you sure you want to cancel filling out the follow up questions?",
		followSuccess: "Submission completed.Thank you for your feedback.",
		followTips: "Follow Up Tips",
		followListTit: "Me-Follow up list",
		followCon: "Please confirm the question about this follow-up of the academic affairs.",
		follow: 'Follow',
		Unfollow: 'Unfollow',
		followed: 'Followed',
		isUnfollowed: 'Are you sure to unfollow?',
		Unfollowed: 'Unfollowed'
	},
	msg: {
		detail: "Details",
		notice: "Notification",
		announcement: "Announcement",
		session: "Message",
		myMsg: "My Message",
		msgDetail: "Message Details",
		category1: "Classroom",
		category2: "Assignment",
		category3: "Comment",
		category4: "Test",
		category5: "Book Class",
		category6: "Follow up",
		category7: "Activity",
		category10: "Preview",
		category8: "Others",
		noticeIframe: "Link to announcements",
		year: "/",
		month: "/",
		day: " ",
		hour: ":",
		minute: " "
	},
	footer: {
		footermenu1: "Daily Edu.",
		footermenu2: "Study Center",
		footermenu3: "Me"
	},
	schedule: {
		courseSchedule: "Curriculum",
		studyPerformance: "Performance",
		commonProblem: "FAQ",
		guidanceExam: "Orientation Test",
		placementExam: "Placement Test",
		stageExam: "Periodical Test",
		finalExam: "Final exam",
		finalEval: "Final Assessment",
		courseProgress: "Progress",
		canBook: "Available number of classes for booking",
		actually: "Number of completed classes",
		absent: "Missed classes",
		studentAbsentBook: "Reschedule due to student’s absence",
		teacherAbsentBook: "Reschedule due to teacher’s absence",
		notBookTime: "unscheduled",
		notStart: "Unstarted",
		studentAbsent: "Student absent",
		teacherAbsent: "Teacher absent",
		toFinish: "Go",
		toDynedFinish: "Go to Dyned",
		hasFinished: "Finished",
		inClass: "in class",
		SignIn: "Sign in",
		ViewCourses: 'View courses',
		Details: "Details",
		Absence: "Absence",
		incomplete: "Unfinished",
		startTask: "Start Task",
		view: "View",
		codeInstall: "Scan QR code to install",
		revisable: "revisable",
		corrected: "corrected",
		frequency: "times",
		bookClass: 'book classes',
		leave: 'Cancel',
		material: 'Materials',
		attendClass: 'Classroom',
		replay: 'Replay',
		classAssignment: 'Class task',
		exercise: "Self-study",
		material1: "Materials",
		homework: "Assignment",
		evalTeacher: "Rate teacher",
		teacherEval: "Teacher’s comment",
		noTime: "N/A",
		reAppointment: "Reschedule class time",
		classPostponed: "Postpone classes",
		noDataWord1: "You haven’t started your study in ",
		noDataWord2: " days this month",
		noDataWord3: "Way to go! Nothing succeeds like success!",
		in: "In ",
		days: " days ",
		sThisMonth: "this month",
		sLastMonth: "last month",
		you: " you...",
		performance: "Performance",
		lastMonth: "Last month",
		thisMonth: "This month",
		section: "Classes",
		finishClassHour: "Completed",
		goToStudy1: "classes.Let's keep learning!",
		goToStudy2: "points.Let's keep learning!",
		exceeded: "surpassed",
		ofStudent: "students",
		exerciseScoreIs: "Self-study score",
		homeworkScoreIs: "Task score",
		//   exceededClassTips: "超过了 xx% 的同学",surpassed xx% students
		//   encourageClassTips: "已完成 x 节课，快去学习吧", finished x classes, Let’s keep learning!
		exerciseScore: "Self-study score",
		//   encourageExerciseTips: "自学得分为 xx 分，快去学习吧", elf-study score xx. Let’s keep learning!
		homeworkScore: "Assignment score",
		//   encourageHomeworkTips: "作业得分为 xx 分，快去学习吧",Your task score is xx, Let’s keep learning
		encourageTips: "Impressive! Way to go!",
		totalPerformance: "Overall performance",
		quarter: "Quarter",
		classTask: "Class task",
		homeworkTask: "Assignment task",
		exerciseTask: "Self-study task",
		exerciseScoreTask: " Self-study score",
		homeworkScoreTask: "Assignment score",
		finalExamScore: "Final score",
		score: "(points)",
		individual: "(tasks)",
		myPerformance: "my progress", //My performance 
		projectNeed: "project standard", // Project requirement
		myPerformance1: "my progress ",
		projectNeed1: " project standard",
		projectNotStarted: "Project hasn't started. Looking forward to your performance!",
		noPaper: "Paper not found",
		noSurvey: "Questionnaire not found",
		pleaseFinishEntranceTestFirst: "Please finish Placement Test first.",
		noLeave: "Leave request rejected",
		leaveOnlyLatestClass: "You can only cancel the most recent class",
		askForLeaveInAdvance: " hours in advance",
		askForLeaveInAdvance1: " hours in advance",
		askForCancel: "Please cancel class ",
		noCancel: "Unable to cancel",
		noCancel1: "Salon class ID not found. Unable to cancel",
		noCancel2: "Class ID not found, cannot be cancelled.",
		noCancel3: "You can't change the time",
		cancelSalon: "Are you sure you want to cancel the salon class?",
		cancelSmallClass: "Are you sure you want to cancel this class?",
		cancelTheme: "Are you sure you want to cancel this topic?",
		classTimeChange: "Your class is rescheduled to",
		attendClassOnTime: "Please attend class on time",
		leaveSuccess: "Leave request accepted",
		classIsOver: "Class timeout",
		toBook: "Book",
		Preference: 'Preference',
		continueStudy: "Way to go",
		taskIsFinished: "Task completed",
		ikonow: "OK",
		neoPlacementTest: "NEO Placement Test",
		entranceTestFinished1: "You have completed the placement test, please wait for our advisors to arrange lectures and teachers for you",
		entranceTestFinished2: "You have completed the placement test, please wait for the project to start to begin learning and booking classes",
		qaCategory: 'Issue classification',
		qaName: 'Issue name',
		qaDetail: 'Details',
		show: 'Unfold',
		hidden: 'Collapse',
		course: 'Course',
		booking: 'Booking',
		leaveProblem: 'Leave',
		trainer: 'Trainer',
		tech: 'Tech',
		studyApproach: 'Study Approach',
		others: 'Others',
		complaints: 'Complaints',
		sales: 'Sales',
		test: 'Placement test',
		voice: 'Voice recognition',
		exerciseTimes: "self study time",
		exerciseTimesIs: "total self study time",
		goToStudy3: ". Let’s keep learning!",
		minutePoints: "(minute)",
		studyTime: "study time",
		redo: "Redo",
		redoConfirm: "Redo assignment?",
		placementExamTips: "Placement test notice",
		placementExamFinishTips: "You have taken the placement test before",
		lessonLabel: "Label: ",
		teacherName: "Teacher:",
	},
	study: {
		recommended: 'Recommended for you',
		trialClass: 'Trial class',
		midterm: 'Mid-evaluation',
    endofterm : 'End-evaluation',
		distanceBegins: "Before start",
		hour: "hours",
		minute: "minutes",
		second: "seconds",
		studycenter: "Study center",
		salonDetail: "Salon details",
		studyTips: "Class alert",
		joinClass: "Enter classroom",
		myLesson: "My course",
		major: "major",
		salonClass: "Salon: ",
		reserveSalonLesson: "Book salon",
		canReserveLesson: "Available",
		reservedLesson: "Booked",
		orderCount: "Progress:",
		lessonTeacher: "Teacher",
		lessonLimit: "Vacancies",
		lessonDifficulty: "Difficulty",
		lessonProgress: "Class progress",
		lessonTodo: "To be done", // Tasks to be done
		lessonTime: "Training time",
		lessonLevel0: "Zero Base",
		lessonLevel1: "Beginner Level",
		lessonLevel2: "Intermediate Level",
		lessonLevel3: "Advanced Level",
		lessonLevel4: "Unlimited",
		orderSuccess: "Booked",
		cancelSuccess: "Canceled",
		cancelOrderLesson: "Cancel",
		startStudy: "Start studying",
		orderLesson: "Book now",
		order: "Book",
		nearDeadline: "Expiring soon",
		lessonStoped: "Pause course",
		topicintro: "Topic Intro",
		studySelf: "Prep work",
		studyTask: "Class task",
		homework: "After class assignment",
		evalTeacher: "Rate teacher",
		teaEvaluation: "Teacher’s comment",
		cancelLesson: "Cancel",
		infoLesson: "Materials",
		startLesson: "Classroom",
		noQuota: "No vacancy for booking",
		quotaUnit: "People",
		numNoQuota: "Unlimited",
		interactionClassroom: "Interactive classroom",
		noLimit: "Unlimited",
		weekdate1: "Monday",
		weekdate2: "Tuesday",
		weekdate3: "Wednesday",
		weekdate4: "Thursday",
		weekdate5: "Friday",
		weekdate6: "Saturday",
		weekdate7: "Sunday",
		yearUnit: ".",
		monthUnit: ".",
		dayUnit: "",
		today: "Today",
		tomorrow: "Tomorrow",
		beforeDawn: "am",
		morning: "am",
		afternoon: "pm",
		evening: "pm",
		noData: "No data",
		classOver: "Class time out",
		classStarted: "Class has started",
		cantCancel: "Unable to cancel",
		noLessonData: "Course material unavailable",
		classsModel: "Training style",
		classTime: "Class time",
		taskName: "Task name",
		countDown: "Count down",
		status: "Status",
		operation: "Operation",
		studentMaterial: "Student’s meterials",
		taskBeforeLesson: "Prep work",
		view: "View",
		toOrder: "Book",
		browserNotSupportAudio: "Your browser does not support audio tag of HTML5"
	},
	book: {
		preselectTitle1: 'Preferred teacher talking speed?',
		preselectTitle2: 'Preferred correction style?',
		preselectTitle3: 'Warm up or ice breaker to start the class?',
		preselectTitle4: 'How do you want the materials to be taught?',
		noRecorded: 'The class is not recorded',
		selectLessonTip: 'The theme you selected does not match. Do you want to continue selecting',
		favoriteTeacher: 'Choose my selected trainer',
		selectTeacher: 'Select teahcer',
		selectTime: 'Select time',
		lessonTime: 'Class time',
		NoScore: 'No score',
		yxls: 'You can also book lessons according to your selected trainer',
		yyxlsdk: 'Book classes by selected trainer',
		ymyyxlsdk: 'Book classes by my selected trainer',
		yztds: 'Book classes by topic',
		bookDetail: "Booking details",
		themeDetail: "Topic details",
		selectTheme: "Select topics",
		selectClassName: "Make an appointment for class",
		reserveLessonTime: "Book class time",
		lessonTheme: "Class topic",
		lessonThemeTips: "Please prepare selected topic to achieve desired study result in class.",
		changeLessonTheme: "Change topic",
		lessonTime: "Class time",
		changeLessonTime: "Change time",
		lessonTeacher: "Teacher",
		lessonTeacherTips: "We have selected the best teacher that matches your availabilities.",
		viewAllEval: "Vie comment",
		bookSuc: "Class booked",
		resetTheme: "Reselect topics",
		allTheme: "All topics",
		bookLessonSelectErr: "The minimum score required for this topic is",
		scoreUnit: "point(s)",
		stillReserve: "Book anyways",
		toPreviewFirst: "Please preview first",
		toPreview: "Preview",
		orderLessonTips: "Each booking requires a minimum of 3,000 points.",
		orderLessonTips2: "You can book one class for every 1.5 hours studied",
		orderedTips: "This topic has been booked",
		orderAgain: "Continue to book?",
		bookCourseDialogContent: "Package name",
		selectTimePlease: "Please select a time slot",
		yourClass: "Your class on",
		changedLessonTime: "has been rescheduled to",
		studyOnTimePlease: "Please attend class on time",
		reserveStudy: "Book class",
		leaveSuc: "Leave request accepted ",
		ChangetimeSuc: "The time change was successful",
		weekLessonStudyTime: "You will have classes at the same time every week. Your first class is shown below",
		timeImproper: "Slots not suitable",
		yourSet: "Your",
		orderedCousreSet: "Your lecture plan has been arranged for",
		completedOperation: "Operation completed",
		pushTimeAsSoonAsPossible: "We will update available slots ASAP",
		selectReserveLessonTimePlease: "Please select your class time",
		requirementOfClassFrequency: "According to class frequency, you need to select ",
		needfulTimes: " slots",
		yourLessonTimeIS: "Your class is at",
		pleaseSelectTheme: "Please select topics",
		confirmCancelThisClass: "Are you sure to cancel booking?",
		confirmCancelLeave: "Are you sure to cancel leave request?",
		confirmGoback: "Are you sure to return?",
		confirmReserveInfo: "Booking confirmation",
		confirmAbandonBookClass: "Are you sure to abort booking?",
		timeIsLack: "Other students are also looking to book these time slots, which are first come first serve. Please confirm as soon as possible.",
		timeImproperPlease: "Time is not suitable, please use English",
		leaveMessages: "Message the teacher",
		timeImproperLeave: "Time is not suitable, message the teacher",
		examConflictTip1: "You have the ",
		examConflictTip2: " test at the selected time. Continue booking class?",
		continueBookClass: "Continue",
		GMTtips: "(For daylight savings time, please calculate manually)",
		noTimeTips: "Please contact your tutor if none of these times work for you",
		videoLesson: 'Support video classes',
		audioLesson: 'no webcam'
	},
	salon: {
		booked: "Number of classes booked:",
		bookedUnit: "",
		spend: "",
		bonuses: " bonuses",
		bookingOpportunity: "One booking opportunity will be used",
		free: "Free",
		cantOrder: "Class cannot be booked due to insufficient booking credit and bonus.",
		learnMore: "Learn how to earn more bonuses",
		confirmGooking: "Confirm booking? You can use your remaining bonus",
		noOrderCantOrder: "Cannot book class due to insufficient booking credits this month",
		bookLimit: "You have reached your daily limit for class bookings",
		bookSuc: "Class booked, ",
		bookSuc2: " yuan will be deducted from your bonus",
		needToApp: "This salon class can only be booked with bonuses, please use the mobile APP to book the class.",
	},
	course: {
		bookCourseDialogTitle: 'Please book class',
		unknownTypeCourseware: "Unknown class material type",
		coursewareConversionFailed: "File conversion failed",
		viewCourseware: "View class materials"
	},
	eval: {
		evaluate: "Comment",
		evalTeacher: "Rate teacher",
		teaEvaluation: "Teacher’s comment",
		overallScore: "Overall evaluation",
		noEval: "No score",
		evalDetail: "Evaluation Details",
		evaldescT: "Teacher rating",
		evaldescW: "Correction Satisfaction",
		gradelevel0: "Terrible",
		gradelevel1: "Bad",
		gradelevel2: "Below average",
		gradelevel3: "Average",
		gradelevel4: "Good",
		gradelevel5: "Excellent",
		textareaPlaceholderT: "Are satisfied with teaching style, sound quality and study results? Please specify your opinion. (No more than 500 characters. This part is invisible to trainers)",
		textareaPlaceholderW: "Please provide your valuable comment/suggestion regarding the teacher’s performance, sound quality and overall satisfaction with the class (200 words max, comments will not be visible to teachers)",
		badTeacherTips: "Unsatisfied with this class? Please let us know the reason so we can improve your experience in the future.",
		likeTeacher: "Like teacher",
		submitSucc: 'Thank you for your prompt feedback!',
		noScore: "N/A",
		confirmCancelEval: "Are you sure to cancel evaluation?",
		noEvalId: "Eval not found",
		evalFinished: "Completed evaluation",
		evalType1: "Certificate obtainment experience",
		evalType2: "Contest participation experience",
		evalType3: "Award winning experience",
		evalType4: "Training target comment",
		evalType5: "Mid-course comment",
		evalTips1: "Congratulations on obtaining the ",
		evalTips2: " certificate, please share your experience",
		evalTips3: "Dear student, the contest has ended, please share your experience",
		evalTips4: "Dear student, congratulations on winning an award, please share your experience",
		evalTips5: "Congratulations on reaching your training targets, please share your learning experience",
		evalTips6: "Please write your comment",
		evalTips7: "The comment shall not be less than 20 words!",
		problemType: "Type of issue",
		teachingMethod: "Teaching method",
		callQuality: "Call quality",
		technical: "Technical",
		others: "Others",
		problemTypeTips: "Please select the type of problem"
	},
	survey: {
		hint: 'Reminder: Questions marked with * are mandatory questions. You can only submit after answering the mandatory questions.',
    myd: 'The purpose of this survey is to understand your satisfaction level with the course',
		questionnaireDescription: "Questionnaire instructions",
		pleaseEnter: "Please enter",
		theNumberBetween: "numbers between xx",
		surveyAnswer: "Answer",
		viewSurvey: "View",
		other: "other",
		tip: 'Please complete all the required quetions marked with"*" then submit.',
		pleaseFillScore: "Please fill in the scores within the scoring range!",
		confirmSubmit: 'Are you  sure to submit?',
		thankYouForSurvey: "Thank you for your prompt feedback!",
		rateLevel1: "Bad",
		rateLevel2: "Below average",
		rateLevel3: "Average",
		rateLevel4: "Good",
		rateLevel5: "Excellent"
	},
	my: {
		lljl: "Browsing history",
		endCourse: "Me-Completed courses",
		myMsg: "Me-My messages",
		myMsgUnit: "messages",
		technicalHelp: "Tech Support",
		setting: "Setting",
		technicalPhone: "Tech support hotline",
		workingHours: "Office hours",
		enquireEmail: "Email",
		multiLanguage: "Multiple languages",
		neoDownload: "Download and install Neo",
		accountSettings: "Account setting",
		information: 'My information',
		userHead: "My Display Picture",
		replaceHead: "Change Picture",
		userNickName: "Username",
		userName: "Name",
		userPassword: "Password",
		userMobile: "Mobile phone",
		userEmail: "Email",
		userWX: "WeChat",
		userSex: "Gender",
		man: "Male",
		woman: "Female",
		userAddress: "Location",
		userDepart: "Department",
		userPasswordTip: 'Have set',
		userMobileTip: 'Have set',
		userEmailTip: 'Have set',
		userWXTip: 'Have set',
		userWXTip1: 'Not set',
		userSexTip: 'Have set',
		userSexTip1: 'Not set',
		userAddressTip: 'Not set',
		userDepartTip: 'Not set',
		userAddressTip1: 'Have set',
		userDepartTip1: 'Have set',
		pleaseInputNickName: "Please enter username",
		uploadFormatIsIncorrect: "Incorrect format, please resend",
		uploadSizeIsOver: "File size cannot exceed 4Mb",
		yourBrowersNotSupport: "Your browser does not support picture upload, please upgrade your browser",
		trainingStart: "Training start:",
		trainingEnd: "Training finish:",
		classStartTime: "Class start time:",
		courseLevel: "Challenge level:",
		courseTeacher: "Trainer:",
		surplusQuota: "Available vacancy:",
		unlimited: "Unlimited",
		inCutting: "Cropping",
		modifyNickname: 'nickname',
		modifyGender: 'gender',
		modifyRegion: 'region',
		modifyDepartment: 'department'
	},
	setting: {
		Newpassword: 'New password',
		setting: "Setting",
		topTitle: "Account setting",
		face: "Profile picture",
		nickName: "Username",
		name: "Name",
		password: "Password",
		toSet: "Go to settings",
		setted: "Setting complete",
		mobile: "Mobile number",
		email: "Email",
		wechat: "WeChat",
		sex: "Gender ",
		male: "Male",
		female: "Female",
		address: "Location",
		department: "Department",
		uploadPicWarning: "Picture upload not supported by browser, please upgrade browser",
		modifySuc: "Edit successful",
		modify: "Edit",
		modifyInputPlaceholder: "Please enter",
		clearCache: "Clear cache",
		updateVersion: "Update",
		clearCacheConfirm: "Are you sure you want to clear cache?",
		logoutConfirm: "Are you sure you want to log out?",
		confirmCancelEdit: "Are you sure to cancel editing?",
		confirmSaveEdit: "Are you sure to save editing?",

	},
	lang: {
		zh: "中文-简体",
		en: "English",
		tw: "中文-繁體",
		languageTips: "Switch language",
		changeLanguage: "Change language?"
	},
	menu: {
		studycenter: "Learning center",
		mine: "Me",
		accountSettings: "Account Setting",
		endedCourse: "Finished Courses",
		notice: "My Message"
	},
	upload: {
		uploadComplete: "Uploaded",
		uploading: "Uploading files...",
		close: "Close"
	},
	neo: {
		setup: "Scan QR code to install Neo",
		ScanQR: "Use your mobile phone to scan QR code",
		coursewareStudy: "Study",
		toDownload: "Download",
		finishTips1: "Download Notice",
		finishTips2: "You have completed the placement test, please download the NEO AI courseware.",
		userAccount: "Account: ",
		userPwd: "Password: ",
		finishTip3: "(Note: the account needs to be activated by the tutor first.)"
	},
	dyned: {
		clickDownload: "Click to download Dyned",
		hasDownload: "Downloaded, go to Dyned to study now",
	},
	IM: {
		UnsupportedFileType: "Unsupported file type",
		FileLarge: "File is too large",
		pic: "[picture]",
		other: "[other]",
		exerciseTaskTips: "Complete the self-study material",
		homeworkTaskTips: "You have one assignment, finish it now?",
		doLater: "Later",
		doNow: "Do it now"
	},
	certificate: {
		targetCertificate: "Target certificate",
		targetLevel: "Target level",
		myCertificate: "My certificate",
		certificateLevel: "Certificate level",
		noCertificate: "You haven’t received a certificate yet, keep up the effort!",
		certificate: "Certificate",
		medal: "Badge",
		integral: "Points",
		scholarship: "Bonus",
		certificateStandardIntro: "Standard for obtaining certificate",
		finalExamScore: "Final-exam score",
		num: "",
		minuteUnit: "minute"
	},
	binding: {
		wxBinding: "Bind WeChat",
		unBound: "Unbind",
		goBinding: "Go to binding",
		hasBinding: "Binded",
		openSweep: "Open the Wechat and sweep it",
		unBoundTitle: "Unbind confirmation",
		unBoundMsg: "Unbind the current account with the displayed WeChat account",
		unBoundConfirm: "Confirm unbinding",
		unbindingSuccess: "Binded successful",
	},

	scholarship: {
		webTips: "Please go to the Daily Education APP to withdraw your bonus",
		buKeTips: "Please go to the Daily Education APP and redeem your class papers",
		awardCode0: 'Manual distribution',
		awardCode1: 'Finish tutorial for the first time',
		awardCode2: 'Complete any lesson and review in 24 hrs',
		awardCode3: 'Respond to the follow-up request within 24 hours',
		awardCode4: 'Top three winner of contests',
		awardCode5: 'Receive certificate of any course',
		awardCode6: 'Meet completion requirements of any project',
		awardCode7: 'Purchased package',
		awardCode8: 'Forward review',
		awardCode9: 'Forward certificate',
		awardCode10: 'Forward contests',
		awardCode11: 'Winner of contests',
		awardCode12: 'Certificates/Projects/Reviews',
		awardCode13: 'Link to your phone number',
		awardCode14: 'Viewed Wechat official account guide page',
		awardCode15: 'submit user research',
		awardCode16: 'Points exchange',
		awardCode17: 'complimentary gift with purchase',
		awardCode18: 'Pod class completion rewards',
		awardCode19: 'Livestreaming class rewards',
		awardCode20: 'Gift with All-you-can-learn',
		awardCode21: 'Volkswagen new users',
		awardCode22: 'Reading rewards',
		awardCode23: 'bounty task rewards',
		awardCode24: 'Survey prize',
		awardCode25: 'Daily attendance',
		awardCode26: 'Winner of contests with friends',
		awardCode27: 'First time login',
		awardCode28: 'Invite new users',
		awardCode29: 'Gift from company',
		awardCode30: 'Study plan competion',
		awardCode31: 'User level upgrade',
		awardCode32: 'Topic completion',
		awardCode33: 'Oral English assessment',
		awardCode34: 'First time login',
		awardCode35: 'Scholarship purchase',
		awardCode36: 'Sign-in',
    awardCode37: 'Fill out the questionnaire',
		exchangeCode0: 'Prize',
		exchangeCode1: 'Deduction in course packages',
		exchangeCode2: 'Deduction in Live speech course',
		exchangeCode3: 'Redeem points',
		exchangeCode4: 'Training camps',
		exchangeCode5: 'Reward',
		exchangeCode6: 'Unlimited pronunciation rating',
		exchangeCode7: 'Reset topic',
		exchangeCode8: 'Redeem topic',
		exchangeCode9: 'Times to redeem',
		exchangeCode10: 'Competition Registration',
		exchangeCode11: 'Unlock hidden articles',
		exchangeCode12: 'Reading',
		exchangeCode13: 'Discuss/Q&A',
		exchangeCode14: 'Video Lessons',
		exchangeCode15: 'Pod-classes',
		exchangeCode16: 'Close Reading',
		exchangeCode17: 'Study Pass 50% Discount Voucher',
		ttltitle: 'Daily AI ',
		ttltip0: 'Topic completion',
		ttltip1: 'Based on topics',
		ttltip2: 'Daily sign-in',
		ttltip3: 'Earn scholarship for daily attendance',
		ttltip4: 'Invite new users',
		ttltip5: 'First time login',
		ttltip6: 'Winner of contests',
		ttltip7: 'Study plan competion',
		ttltip8: 'Gift from company',
		ttltip9: 'User level upgrade',
		ttltip10: 'Study plans',
		ttltip11: 'Complementary gifts',
		ttltip12: 'Based on levels',
		jxjtitle: 'Daily educstion',

		jxjdq: ' scholarship is about to expire',
		oneOnOne: '1 one-on-one session',
		smallGroup: 'small-group class scholarship only',
		canuseScholarship1: 'Available points',
		title1: 'Redeem points with scholarship',
		title2: 'Redeem scholarship with points',
		title3: 'Manually enter',
		dhbtn: 'Redeem',
		sx1: 'How to get',
		sx2: 'Types of spending',
		conB: 'Confirm',
		lsee: 'I understand',
		scholarshiptitleGQ: 'Overdue record',
		scholarshiptitle1: 'Scholarship received',
		scholarshiptitle2: 'Scholarship spent',
		scholarshiptitle3: 'Total received scholarship',
		scholarshiptitle3_: 'Total received points',
		scholarshiptitle4: 'Filter',
		scholarshiptitle5: 'How to get',
		scholarshiptitle6: 'How to get',
		scholarshiptitle7: 'Points received',
		scholarshiptitle8: 'spending records',
		scholarshiptitle9: 'Total spent scholarship',
		scholarshiptitle9_: 'Total spent points',
		scholarshiptitle10: 'Expired',
		reward: 'Withdraw the reward',
		myScholarship: 'My scholarship ',
		myJf: 'Points',
		exchangePrizes: 'Scholarship Mall',
		togetScholarship: 'Pending',
		courseExchange: 'Redeem classes',
		exchangeRecord: 'Redeem records',
		guidanceExamTips: 'Do not forget to complete the pre-study tutorial to earn more bonus!',
		moreRewards: 'More reward earning tasks',
		reward1: 'Finish a tutorial prior to taking any course',
		reward2: 'Complete a lesson and review in 24 hrs',
		reward3: 'Meet all requirements of any project',
		reward4: 'Respond to follow-up request in 24  hrs',
		reward5: 'Receive certificate of any course',
		reward6: 'Contests winning',
		reward7: 'Complimentary gift with purchase',
		reward8: 'Certificates/Projects/Reviews',
		reward9: 'Pod-class awards',
		reward10: 'Livestreaming class awards',
		reward111: 'Task reward',
		scholarship: 'Scholarship',
		morePrizes: 'Stay tuned for more prizes',
		viewExchangeRecord: 'Check redeem records',
		canuseScholarship: 'Available scholarship',
		exchangeSuccess: 'Prize has been successfully redeemed',
		youCanSee: 'You can view in the redemption history',
		confirmExchangePrizes: 'Confirm to redeem ?',
		hasScholarship: 'Bonus earned',
		getIt: 'withdraw',
		tabelTime: 'Time',
		tabelName: 'Name',
		tabelNum: 'Num',
		toView: 'View',
		reward11: 'Scholarships obtained from certain channels have an expiration date, please use them before they expire. For scholarships that are about to expire, there is an expiration reminder on the current page, please check.',
		// 分享一个小秘密，首次转发至朋友圈后, 可获得更多奖励哦！
		// Here's a little secret, you can earn more rewards for sharing in your WeChat friend circle for the first time!
		// shareOne: "分享一个",
		// littleSecrets: "小秘密",
		// firstForward: ", 首次转发至朋友圈后, ",
		// getMoreRewards: "可获得更多奖励哦！",
		getSuccess: 'Success',
		deposited: 'Saved ',
		account: ' account',
		gotoForward: 'Share',
		clickToLook: 'Click to view',
		getOneReward: 'Click to get rewarded', // You have obtained 1 opportunity to get rewarded
		// firstForward1: "首次转发至朋友圈后，可",
		// getMoreRewards1: "获得更多奖励哦！",
		gotoReward: 'Get now',
		congratulations: 'Congratulations',
		forwardToShowOff: 'forward to the circle of friends to show off.',
		toUse: 'To Use',
		explain: 'Explain: ',
		selectMakeUpClass: 'Please select the lesson you want to make up',
		selectMakeUpCourse: 'Please select the course you want to make up',
		makeUpSuccess: 'Successful',
		clickHere: 'Click here to check',
		absentLessonChanged: 'Make up class scheduled',
		scholarshipNotEnough: 'Insufficient scholarship to redeem',
		cannotMakeUp: 'You have not yet missed any class or the make-up voucher does not match the length of the absent class. The make-up voucher cannot be redeemed.',
		bookNumAdd: '1 class has been added to your booking limit',
		dxcs: 'Tutorial',
		kspj: 'Class review',
		fkgj: 'Follow Up Results',
		kcs: 'Course certificate received',
		xmdb: 'Finished projects',
		jshj: 'Contests winning',
		tczs: 'complimentary gift with purchase',
		pj: 'Certificates/Projects/Reviews',
		jk: 'Pod-class awards',
		zb: 'Livestreaming class awards',
		jp: 'Prizes',
		dk: 'Deduction in course packages',
		slk: 'Deduction in Live speech course',
		dh: 'Redeem points',
		Switch: 'Switch',
		tip1: 'Please enter number',
		tip2: 'Round to 2 decimal places',
		tip3: 'Please enter a number greater than 0',
		tip4: 'Please enter an integer greater than 2',
		tip5: 'This redemption costs ',
		tip6: 'The number must be an integer greater than 0',
		qb: 'All',
		jszt: 'Unlock topics',
		jsbm: 'Sign up for contests',
		czzt: 'Reset topics',
		dhkc: 'Redeem courses',
		gmlypf: 'Buy grading chances',
		lypf: 'Recording grades',
		qd: 'Daily attendance',
		sqdl: 'Invite new users to login',
		scdl: 'First-time login',
		pkhs: 'Compete with friends-winner',
		wcjh: 'Complete study plans',
		fz: 'Gifts(Gift from company, gift from purchase etc)',
		jxjdh: 'Redeem with scholarship',
		ny: 'Your ',
		jfjjdq: 'points are about to expire',
		jxjjjdq: 'scholarship are about to expire',
		ljsg: 'Use now'
	},
	label: {
		setTags: "Set tags",
		defaultTags: "Default tags",
		selectTags: "Select tags",
		selectInterested: "Please select other contents you are interested in",
		labelNote: "Note: tags cannot be changed after selection",
		canSelectLimit: "You can select up to ",
		canSelectLimitUnit: " tag",
		canSelectLimitUnits: " tags",
		selectTagsPlease: "Please select a tag",
		selectTagsConfirm: "Tags cannot be changed after confirming, proceed?",
		setComplete: "Complete",
		selectTips1: "You can also select ",
		selectTips2: " label"
	},
	level: {
		selectLevel: "Select level",
		currentLevel: "Current target level",
		historyLevel: "Target level history",
		todoTest: "Pending tests"
	},
	exam: {
		Evaluationoftest: 'Evaluation of test',
		appointmentExam: "Reserve",
		CancelExam: 'Cancel',
		appointmentExamconfirm: "Confirm",
		Waiting: 'Waiting',
		Results: 'Results',
		Uncompleted: 'Uncompleted',
		examTip01: 'Time is not up',
		examTip02: 'The teacher is evaluating your speaking ability',
		examTip03: 'Speaking test requires camera on.',
		examTip04: 'The test is over',
		examTip05: 'Your exam has not been completed. If you have any questions, please contact Educational affairs',
		examReminder: "Test reminder",
		joinExam: "Enter test",
		examTime: "Test time: ",
		start: "Start",
		examNotStart: "Please wait, the test hasn't started yet",
		examfinished: "The exam is over",
		examTips: "Test notes",
		examTips1: "1.Please pay attention to the test time. Once you have entered the test, the timer will start. Your test will be submitted automatically once it is completed.",
		examTips2: "2.Exercises cannot be viewed during the test. Test paper cannot be viewed after submission.",
		examTips3: '3.To check your test scores go to "me—participated"',
		competition: "Contest",
		examTitle: "Test",
		examScore: "Test scores ",
		toBeCorrect: "To be corrected",
		level: "level",
		reset: "Reset",
		clickStartExam: "Click to start exam"
	},
	smallClass: {
		themeTab1: "Select based on time",
		themeTab2: "Select based on theme",
		hasApplyed: "Booked",
		hasBookedFull: "Fully booked",
		lessonTeacher: "Minutes",
		duration: "Duration",
		minuteUnit: "minutes",
		intro: "Introduction",
		consume: "consume",
		bonuses: "",
		enbonuses: "number of class ",
		seedetail: "detail"
	},
	favoriteTeacher: {
		favoriteTeacher1: 'trainers',
		szyx: 'I have added this teacher to my My selected trainer list.',
		qxyx: 'I have removed this teacher to my My selected trainer list.',
		select: 'Set as preferred teacher',
		cancelSelection: 'Cancel',
		set: 'Trainer has been selected.',
		cancel: 'Selected trainer has been canceled. ',
		addTeacher: 'Has been added to my list of non-recommended teachers',
		cancelTeacher: 'Cancel my list of unrecommended teachers',
		mloveTeacher: 'My Preference ',
		mloveTeacher1: 'My Preference ',
		jsfy: 'Accent',
		ktfw: 'Classroom Atmosphere',
		qsys: 'Adaptable and Open-minded',
		rzys: 'Strict and Responsible',
		skfg: 'Teaching Style',
		tip: 'Tips：For preselect class,we will match you with a teacher according to your preference,based on their availability',
		clear: 'Clear all',
		zsxq: 'Select at least one item',
		zsph: 'Set my Preferences',
		phls: 'Selected',
		videoLesson: 'Support video classes',
		audioLesson: 'no webcam'
},
	robot: {
		nodata0: 'Xiaozhi found that there is no dialogue yet',
		nodata1: 'Xiaozhi found no new notifications',
		nodata2: 'Xiaozhi found no class notice',
		nodata3: 'Xiaozhi found no preview notice',
		nodata4: 'Xiaozhi found no homework notice',
		nodata5: 'Xiaozhi found no review notice',
		nodata6: 'Xiaozhi found no exam notice',
		nodata7: 'Xiaozhi found no class booking notice',
		nodata8: 'Xiaozhi found no activity notification',
		nodata9: 'Xiaozhi found no notification',
		pic: '[Images]',
		sound: '[Audios]',
		qt: '[other]',
		sp: '[Video]',
		delMsg: 'Delete the message',
		hddd: 'This is the bottom of the page',
		qklb: 'Confirm to clear the current list?',
		xxx: ' new messages',
		notifications: 'Notifications',
		conversations: 'Conversations',
		unread: 'Unread',
		yx: 'Preview',
		status1: 'In progress',
		status2: 'Completed',
		status3: 'Ungraded',
		status4: 'Corrected',
		status5: 'Unclaimed',
		status6: 'Claimed',
		status7: 'Not obtained',
		status8: 'Obtained',
		status9: 'Student absent',
		status10: 'Teacher absent',
		status11: 'Student absent make-up',
		status12: 'Teacher absent make-up',
		status13: 'Unrated',
		status14: 'Rated',
		Details: 'Details',
		name: 'Xiaozhi',
		help: 'Help',
		set: 'setting',
		cleartitle: 'Clear the chat logs',
		tip1: "Hello! I am Xiaozhi, your personal learning assistant, and I will pay close attention to your learning from now on! Let's work hard, and make some progress each day. Please feel free to ask me whenever you have questions. ",
		tip2: 'Now please set up your account with me!',
		g5title: 'Start 5.0 tutorial',
		sq: 'Allow authorization',
		sqtitle: 'This APP would ask for your permmision',
		record: 'record',
		tip3: 'be used for sound recording and speech recognition',
		tip4: 'Send notifications',
		tip5: 'Send messages about software upgrading, and learning-related content',
		tip6: 'Please grant these permissions, otherwise these functions may not be used properly. You can go to "settings">"authorizations"to cancel your permissions.',
		tip7: "You haven't enabled authorization to use microphone. Tap below to enable",
		tip8: "You haven't enabled authorization to send notification. For android devices, please go to application management to enable permission. Tap below to enable",
		sq1: 'This APP would ask for your permmision',
		sq2: 'Be used for sound recording and speech recognition',
		sq3: 'Access granted',
		xxysx: 'The message is dead',
		xxyc: 'Message exception'
	},
	dialogue: {
		XPJ: 'Write a review',
		dialogue: 'Settings',
		delword: 'All the chat history initiated by you will be erased',
		delSuss: 'Deleted',
		word: 'You can go to "skills" page to check out what Xiaozhi can do!',
		nospeach: "You haven't said anything",
		bindSuss: 'Linked successfully',
		haschangeBandage: 'your current account has been linked',
		bindBad: 'Failed to link: Your current Wechat account has been linked to another account',
		morning: 'Good morning',
		afternoon1: 'Good afternoon',
		afternoon2: 'Good afternoon',
		evening: 'Good evening',
		stillAwake: 'You are still awake',
		askword: 'You could say to me like:',
		Skills: 'Skills',
		Change: 'Change a batch',
		speak: 'Start speaking ',
		dk1: '"Book a class"',
		dk2: '"Class schedule"',
		dk3: '"leave request"',
		dk4: '"Check scores"',
		zx1: '"Self study"',
		jf: '"Points"',
		yhq: '"Coupons"',
		jxj: '"Scholarships"',
		word1: 'Tap speak',
		word2: 'Tap end',
		youask: 'You replay...',
		youask1: 'You could say',
		exTile: 'Test title',
		kcTile: 'Course',
		ksTile: 'Lesson',
		openPaper: 'Start the test',
		cando: 'I can do a lot of things: I can remind you to preview, take classes, do homework, write reviews, and so much more! You can check all my skills on your phone.',
		admissionTest: 'A placement test is available for you',
		noadmissionTest: "You don't have any placement tests right now",
		LevelTest: 'You have a "level test" to complete. ',
		noLevelTest: "You don't have a 'level test' to take right now",
		phaseTesting: 'An assessment is available for you',
		nophaseTesting: "You don't have any assessments right now",
		completionTesting: 'A final exam is available for you',
		nocompletionTesting: "You don't have any final exams right now",
		testing: 'Found the most recent test for you',
		notesting: "You don't have any tests right now",
		exam: 'Found the most recent exam for you',
		noexam: "You don't have any exams right now",
		course: 'Opening your schedule',
		interactiveClassroom: 'Opening your interactive classroom',
		noInteractiveClassroom: "You don't have any classes right now",
		preview: 'You have "preview" assignment to do',
		nopreview: "You don't have any self study assignments right now",
		homework: 'You have homework to complete',
		nohomework: "You don't have any homework assignments right now",
		exchangePrizes: 'Opening make-up class coupon page',
		absentLesson: 'If you want to make up a class, go to make-up class coupon page to redeem your coupons.Opening make-up class coupon page… ',
		noabsentLesson: 'You do not need to make up a class right now',
		grades: 'Opening your most recent test score page',
		nogrades: "You don't have any test scores right now",
		classbook: 'Opening "book a class" page',
		hasclassbook: 'For which course do you wish to book a class',
		noclassbook: 'Opening "book a class" page',
		appraisals: 'You can write reviews for the following classes',
		noappraisals: 'You do not have to write any reviews',
		lookReviews: 'Jumping to your most recent review',
		nolookReviews: "You haven't received any reviews yet",
		absence: 'Opening "leave request" page for you',
		noabsence: "There aren't any classes for you to request for leave",
		daionMall: 'Opening Daily Mall',
		oralTraning: 'Opening Daily AI Drill',
		achievement: 'Opening "achievements"',
		noachievement: "You haven't received any certificates yet",
		certificate: 'Opening "achievements"',
		nocertificate: "You haven't received any certificates yet",
		myScholarship: 'Opening "scholarship" page',
		integral: 'Opening "points" page',
		coupon: 'Opening "coupons" page',
		binding: 'Your current account has been linked already!',
		hasbinding: 'Link changed successfully',
		nohasbinding: 'Failed to change link. Please contact your study advisor',
		unknown: "Xiaozhi couldn't follow. Please say it again!",
		relax: "I'll take a break.",
		xiaozhi: 'I am here. What can I do for you?',
		voiceplayback: 'Voice announcement is on',
		trainingCamp: 'Opening "training camp" page for you',
		notrainingCamp: 'There are no training camps for you to join now',
		starTrainer: 'Opening "Star trainers" page for you',
		nostarTrainer: 'There are no Star trainers classes to sign up now',
		podclass: 'Opening "Pod-class planet" page for you',
		nopodclass: 'There is no pod-class to subscribe now',
		searchWord: '正在为你跳转',
		nosearchWord: '当前词库暂无搜索结果哦'
	},
	ability: {
		title: 'Try to see what Xiaozhi can do!',
		Skill: 'Skills demo',
		question1: 'About tests and exams. Try to say:',
		question2: 'About classes, schedules and scores. Try to say:',
		question3: 'About booking classes, reviews and leaves. Try to say:',
		question4: 'About scholarships, points and coupons. Try to say:',
		question5: 'About Daily AI Drill. Try to say:',
		question6: 'About linking accounts. Try to say:',
		question7: 'Audio-related questions',
		ceshi1: '"Test/exam"',
		ceshi2: '"Enrollment test/Placement test"',
		ceshi3: '"Midterm exams"',
		ceshi4: '"Final test"',
		ceshi5: '"Self study/Preview"',
		ceshi6: '"Homework"',
		sk1: '"Take a class"',
		sk2: '"Make up a class"',
		sk3: '"Make-up class coupon"',
		sk4: '"Check schedule"',
		sk5: '"Check scores"',
		sk6: '"Achievements/Certificates"',
		dk1: '"Book a class/Choose a class"',
		dk2: '"Write a review"',
		dk3: '"See reviews"',
		dk4: '"Leave request/Cancel"',
		jsj1: '"Check my scholarships"',
		jsj2: '"Check my points"',
		jsj3: '"Check my coupons"',
		jsj4: '"Daily AI Drill"',
		bd1: 'Link',
		ss: 'Have a try',
		tip1: 'How to activate voice control?',
		tip2: 'Xiaozhi cannot recognize my speech/misrecognize my speech',
		see: 'Look over into',
		question8: 'Training camp and Pod-class. Try to say:',
		xly1: '"Training camp"',
		xly2: '"Star Trainers"',
		xly3: '"Pod-Class"',
		cckys: 'Look up the dictionary, try to say：',
		ci1: '"look up pronunciation"',
		ci2: '"look up where"',
		ci3: '"look up apple"',
		ci4: '"look up map"'
	},
	quesiton: {
		name: 'FAQ',
		title1: 'How to use',
		title2: 'Notification',
		tip1: "Turn on the microphone permission > tap Xiaozhi's avatar or shake the phone to enter the conversation page, follow the instructions at the bottom > tap the voice button to speak > tap end to send.",
		tip2: "If the voice control doesn't respond, the reason might be:",
		tip3: '1. Be close to the microphone and speak in normal speed. Speak mandarin if possible',
		tip4: '2. When misrecognition occurs, try to have a back-and-forth conversation to revise the misrecognized parts. Example: "review+check/write"',
		tip7: '1. Access to microphone is not allowed',
		tip6: '2. Microphone is occupied by other audio players (e.g. music playing in the background)',
		next: 'Next',
		tip5: 'previous',
		title3: 'Causes',
		title4: 'How to activate voice control?',
		title5: 'Xiaozhi cannot recognize my speech？',
		tip9: 'Xiaozhi may not recognize your speech accurately in noisy environment, or when you have a strong accent etc.'
	},
	RobotCourse: {
		Classschedule: 'Class schedule',
		Selected: 'Selected',
		UpcomingClass: 'Upcoming',
		ScheduledClasses: 'Scheduled',
		Classes: 'C'
	},
	learning: {
		name1: 'All-you-can-learn',
		name2: 'Learning center',
		ceshi: 'Placement test',
		ceshi1: 'Study plan',
		studyPlan: 'Custom learning program',
		trainingCamp: 'Training camp',
		ceshiBtn: 'Proceed to test',
		levelHint2: ' users have taken the test ',
		lessonProgress: 'Progress',
		major: 'Other courses you might be intereated in',
		classtime: 'Total lessons ',
		period: 'Learning period ',
		bespokenum: 'Available times ',
		paln1: 'xx mins today',
		paln2: 'Earned points/PTS',
		paln3: 'xx days in a row',
		jrzb: 'Enter live class',
		qxx: 'Start learning ',
		tab1: 'Daily AI Drill',
		tab2: 'Star Trainers',
		tab3: 'Pod-Class',
		tab4: 'Reading',
		tab5: 'Watching',
		zxdf: 'Earned ',
		zxf: 'Total',
		fjs: ' unlock',
		title1: 'Daily Sentence',
		hint1: 'Famous sayings and beautiful sentences ',
		title2: 'IChallenge',
		hint2: 'Practice your spoken English with friends',
		grades1: 'Basic',
		grades2: 'Standard',
		grades3: 'Advanced',
		grades4: 'Premium',
		exitApp: 'Tap to log out',
		c: 'time',
		ckgd: 'More',
		hyp: 'Refresh',
		zjgx: 'Updates',
		bzxicc: '本周学习时长',
		bzhdxf: '本周获得学分',
		bzhhdjj: '本周获得奖学金',
		nhkus: 'Other Columns'
	},
	mc: {
		see: 'Detail',
		ydy: '人已订阅',
		cy: '人参与',
		z: '赞',
		microCourse: 'Pod-Class Planet',
		detail: 'Details',
		intro: 'Introduction',
		discuss: 'Discussion',
		evaluate: 'Pod class reviews',
		pinputi: 'Please enter the title',
		seo: 'Search',
		all: 'All',
		dy: 'Subscribe',
		g: 'in total ',
		qs: ' issues',
		iswj: 'Update completed',
		tg: 'Group',
		yg: 'people have purchased',
		t: '团',
		c: '促',
		jd: 'Progress:',
		day: ' days',
		hasyx: 'Learning period: ',
		xq: 'Pod class details',
		kcyxq: 'Remain ',
		jl: 'Award',
		jxj: 'scholarships',
		hfsc: 'Estimated duration of this course:',
		scgz: 'Course duration',
		sc: 'The estimated duration includes audio and video learning and consolidation exercises (if any). The length of study varies from person to person. Please arrange the study time reasonably!',
		gz: 'Reward rules',
		title: 'Complete all the existing classes of the pod-class, and receive an award',
		qd: 'Confirm',
		ml: 'Content',
		pj: 'Review',
		qpj: 'Write a review',
		gm: 'Purchase now',
		jq: 'Coupons',
		lyhj: 'Get coupons',
		yhj: 'Yuan off',
		off: ' off',
		qdl: 'Congratulations! You got it. ',
		ljlq: 'Get now',
		lqcg: 'Success',
		tgy: 'ppl',
		money: ' Yuan',
		s: 'save',
		tghd: 'Group buying',
		tgj: 'Group-buying price',
		qrct: 'confirm to join',
		kt: "I'd like to host a group",
		qkgm: 'Please purchase this course to keep learning!',
		xm: 'Free',
		ms: 'Flash sale',
		gxz: 'Updating',
		st: 'Trial',
		noyhj: 'No available coupon',
		kx: ' coupons can be applied',
		dk: 'use scholarship',
		dkje: 'Enter amount',
		jfdhb: 'Redeem',
		name: 'Name',
		phone: 'Phone number ',
		tilte: 'Use up to xx to purchase the current course package',
		hint1: 'I have read and agreed to the',
		hint2: '"Daily Course Service Agreement"',
		hint3: 'confirmed the authenticity of the course, and agreed to pay the registration fee',
		yjxj: ' CNY scholarship',
		kcxj: 'This course was taken down/Invalid course',
		Ahas: 'remain ',
		nowday: 'Expire today',
		noexchage: 'Payment amount does not need to redeem scholarship',
		dhcg: 'Exchange succeeded',
		qxsc: 'Unsaved successfully',
		sccg: 'Saved successfully. Check in Me-Collections',
		gxqd: 'Congratulations! You got it. ',
		ymsq: 'Please close the page and re-enter the authorization',
		share1: 'Limited time offer! Hurry up!',
		share2: 'Join in the group buy with me ！',
		share3: ' Invites you to learn together',
		yhsx: 'The offer has expired. Please pay the original price. ',
		ctes: 'minimum number of people',
		ren: 'people',
		conkt: 'Confirm to host a group?',
		conct: 'Confirm to host a group?',
		tz: 'Host',
		myct: 'Join a groupp',
		gq: 'This group has expired. Please join in other groups. ',
		userAgreementCheck: 'Please read and agree to the "Daily Course Service Agreement"',
		jxjhint: 'The scholarship amount has changed, please refresh the page to re-purchase',
		bmcg: 'Sign up successfully',
		gmcg: 'Successful transaction',
		dqyy: 'You have',
		ljjf: 'total points',
		zfsy: 'You can use  in this purchase',
		jfdhc: 'Redeem points to',
		kdh: 'available to redeem',
		isdh: 'Redeem all?',
		jxjdk: 'Use scholarship',
		bmjz: 'Sign-up closed',
		yxj: 'taken down/invalid',
		cytg: 'Join a group ',
		tgjd: 'Progress',
		jzsj: 'DDL',
		jrzbj: 'Enter',
		xsyh: 'sale',
		totle: 'Total ',
		wxzf: 'Wechat pay',
		gmkg: 'Purchase',
		wks: 'Not started',
		tgkg: 'Group',
		phoneV: 'Phone verification code',
		fsyzm: 'Send',
		yzmsb: 'Failed to send verification code, please try again',
		yzmfs: 'Verification code already sent. Please check your notification.',
		bfspky: 'Selected items',
		m1: 'Every ',
		sy: ' to use',
		xsmf: 'Free for a limited time',
		jljs: 'End in',
		rct: '人成团',
		zjcy: 'Join group buy directly',
		nmuesr: 'Anonymous user',
		jjs: 'End in ',
		qct: 'Join',
		less: 'Short',
		xzyhj: 'Choose coupons',
		nsyyhj: 'Do not use coupons',
		video: 'video',
		audio: 'audio',
		yhq: 'Coupons',
		rdy: ' subscribers',
		xxjl: 'Learning rewards',
		yhdk: 'Discounts',
		bcdk: '本次抵扣',
		xqjs: '詳情介紹',
		kslb: '課時列表',
		kcmu: '課程目錄',
		pl: '評論',
		spkP: '搜索系列課標題、講師姓名',
		ztspk: '主題視頻課',
		bs: '倍速',
		lx: '練習',
		sfdykc: '您尚未訂閱當前課程，是否現在訂閱？',
		zbdy: '暫不訂閱',
		ljdy: '立即訂閱',
		xxdy: '當前視頻課需要訂閱後學習哦',
		chapter: 'chapter'
	},
	column: {
		name: 'Column details',
		xxjd: 'Learning progress'
	},
	live: {
		zjls: 'Instructor',
		isApply0: 'Available',
		isApply1: 'Signed up',
		isApply2: 'Unavailable',
		zbsj: 'live time: ',
		ryx: ' learners',
		teacher: 'Instructor',
		more: 'more',
		zbjj: 'live info',
		kcap: 'Schedule',
		yx: 'Follow',
		qxyx: 'Unfollow',
		hf: 'Replay',
		name: 'Livestream info',
		hint1: 'Gnerating live session playback, please wait',
		hint2: 'Playback for this live session is expired',
		hint3: 'You can only enter the most recent class that has not started.',
		hint4: 'This live session does not allow playback.',
		title: 'Receive awards after completing all the livestream lessons',
		ddque: 'order confirmation ',
		name1: 'Star Trainers',
		gzcg: 'Followed successfully',
		jpls: 'Star trainer',
		ybm: 'Signed up sessions',
		rybm: ' Signed up',
		xxgjc: 'Swipe down to explore',
		jzsj: 'DDL',
		jrapp: 'Please go to APP learning'
	},
	teaDetail: {
		teacherDetails: "Instructor's bio",
		introduction: 'Introduction',
		evaluation: 'Reviews',
		relatedCourses: 'Courses',
		personalProfile: 'Personal profile',
		teacherExperience: 'Teacher experience',
		certificate: 'Certificate',
		noTeaDetail: 'There is no detailed introduction for this trainer. '
	},
	share: {
		user: 'DailyUser',
		joinMe: 'I am learning, join me～',
		QRcode: 'Long press to scan the QR code',
		word: 'You are invited to learn Daily English courses!',
		word1_1: 'You are invited',
		word1_2: 'to learn Daily',
		word1_3: 'English courses!',
		word2_1: 'You are invited to',
		word2_2: 'learn Daily English courses!',
		Share: 'Share this here',
		wx: 'Wechat',
		frend: 'Wechat moments',
		Im: 'I am'
	},
	MCLesson: {
		lessonDetail: 'Lesson detail',
		completed: ' Completed ',
		Progress: 'Progress',
		teacher: 'Teacher',
		wenti: 'Ask a question',
		nodataTip: 'No one has asked a question yet. Take the first floor!',
		enterTip: 'Please enter your question!'
	},

	trainingCampDetail: {
		trainingCampDetail: 'Training camp Detail',
		trainingCampIntroduction: 'Training camp introduction',
		free: 'Free',
		share: 'Share',
		signUpNow: 'Sign up now',
		addStudyAdvisor: 'Add study advisor',
		signedSuccess: 'Sign up successfully',
		seconds: '后自动跳转至添加课程顾问页面',
		wjfwfbm: 'You cannot sign up since there are no points in your account',
		jf: 'Points',
		jxj: 'Scholarships',
		daydayStudy: 'Dane practices English every day'
	},
	levelTest: {
		title1: 'Aligned to CEFR',
		title2: 'Guaranteed reliability',
		yy: '已有',
		rwccs: '人完成水平测试',
		Instruction: 'Instruction',
		tip1: ' 1、It takes about 15 minutes to complete the test. Please reserve enough time. ',
		tip2: ' 2、Please turn on your microphone.',
		tip3: ' 3、Please wear headphones for the test.',
		Starttesting: 'Start testing',
		mkfqx: 'Please allow access to microphone',
		rxcj: 'The system finds that you have taken the placement test before, and has obtained your test score as ',
		nobingWx: "You haven't linked your Wechat to your account"
	},
	lessonAudio: {
		title: 'Course recording'
	},
	TTlexam: {
		title: 'Your current English level is',
		ozty: 'CEFR Level',
		jb: '',
		cancs: 'With your current English level, you can',
		g: '',
		tm: ' questions in total',
		clear: 'Delete',
		tj: 'Submit',
		yyspcs: 'Placement test',
		tjcg: 'Submitted successfully',
		tjsb: 'Submission Failed',
		qktm: 'Clear questions',
		xztkt: 'Multiple choice',
		tkttitle: 'Listen to the audio and choose the option to fill in the blank.',
		tkttitle1: 'Choose the option to fill in the blank',
		txda: 'Please fill in your answer',
		hasLimit: 'Playback limit reached',
		mst: 'Read along',
		mstbjyyc: 'Part of this sentence is hidden. Please read after the audio',
		mstbjyyc1: 'The sentence is hidden. Please read after the audio',
		mstbjyyc2: 'The sentence is hidden. Please read after the audio',
		mstvideo: 'Listen to the audio, and tap the record button to answer',
		ksly: 'Start recording ',
		jsly: 'End recording ',
		djjsly: 'Tap the waves to end recording',
		qbfly: 'Please listen to the audio before recording',
		txt: 'Dictation',
		mxcl: 'Listen to the audio, and write down what you hear',
		tdscda: 'Tap start to type down your answer',
		txda1: 'Please fill in your answer',
		tkt: 'Fill in the blanks',
		tyypx: 'Listen to the audio, and write down what you hear',
		kbcsdnr: 'Please fill in your answer',
		pxt: 'Sorting',
		pxttltle1: 'Listen to the audio and reorder the following words',
		pxttltle2: 'Reorder the following words',
		txttltle2: 'Tap the word, or drag the word into the area',
		dtsj: 'Time is up',
		sb: 'Failed to start recording',
		csjg: 'Test results'
	},
	myword: {
		del: 'Delete',
		myword: 'My vocabulary',
		playAll: 'Play all',
		review: 'Review',
		setting: 'Setting',
		definition: 'Definition',
		sortBy: 'Sort by',
		AZ: 'A-Z',
		ZA: 'Z-A',
		nearTime: 'Newest',
		Timeold: 'Oldest',
		sub: 'Submit',
		English: 'British',
		American: 'American',
		savecg: 'Saved',
		word: '',
		learn: 'learned',
		Topics: 'Lists',
		cszt: 'Lists',
		alltopics: 'All lists',
		startLearning: 'Start learning',
		New: 'New',
		All: 'All',
		nearlearned: 'recently learned',
		next: 'Next',
		previous: 'Previous',
		zmpx: 'A-Z',
		gxhip: "Congratulations! You have completed today's review. ",
		addword: 'Added to my vocabulary',
		delword: 'Unsaved from my vocabulary',
		gxtip: 'Congratulations! You have completed this topic.',
		xxjd: 'Progress',
		hdztlb: 'Back to topic list',
		nextTopi: 'Next topic',
		sy: 'Definition',
		saveSuss: 'Saved',
		noyuyin: 'No voice recording',
		ddjs: 'Wait till the audio finish',
		sfqx: 'Confirm to delete',
		qfx: 'Review',
		qxx: 'Study',
		ly: 'Source',
		tznr: 'Rlated content',
		xq: 'Detail',
		back: 'Back',
		such: 'Search vocabulary',
		suls: 'Search history',
		chls: 'Clear history',
		claerchls: 'Confirm to clear history?',
		suplear: 'Please type Chinese or English to search',
		jy1: 'Only supports English apostrophes, commas, hyphens',
		jzjr: 'As of today',
		wc: 'completed',
		playW: 'Study with me now'
	},
	communicate: {
		tip0: 'Please use text to describe the problem. The audio may be unclear and affect the accuracy of the answer!',
		tip1: 'The teacher will communicate with you soon, please wait a moment',
		skfs: 'Release to send',
		azsh: 'Press and speak',
		pleaseenter: 'please enter',
		gift: 'Gifts',
		giftRecords: 'Gift records',
		noinput: "You haven't entered anything yet",
		uploading: 'Uploading…',
		flower: '鲜花',
		salvo: '礼炮',
		suger: '糖果',
		paper: '爱的纸鹤',
		rockets: '真爱火箭',
		clouds: '冲上云霄',
		diamond: '钻戒',
		hug: '爱的抱抱',
		sending: 'Sending',
		nojxj: 'Insufficient scholarship balance',
		isSending: 'Sending',
		lyd: 'Audio message is too short to send',
		recording: 'Recording',
		tomore9: 'Upload no more than 9 files！',
		tobig: 'File  is too large. Please reupload',
		toType: 'The format of the uploaded file is incorrect, please try again！',
		uply: 'Uploading recording',
		allemo: 'Emojis',
		zjsh: 'Recent use',
		spjz: '上传视频加载中 请稍后',
		ltsx: '您的聊天功能已受限，建议您重新登录',
		IMbad: 'IM 未登录成功 请刷新 重新登录'

	},
	coupon: {
		name: 'My coupons',
		type: 'General',
		off: 'off',
		qcspky: 'Apply to all products',
		ljlq: 'Use now',
		m1: 'Reduction',
		sy: 'Use',
		money: 'Yuan',
		zgj: '最高减',
		gq: 'Expire soon',
		zdky: 'Apply to selected products',
		zdbky: 'Not applicable to selected products',
		yxq: 'Effective date'
	},
	order: {
		courseOrders: 'Course orders',
		orderTime: 'Order time',
		successfulTransaction: 'Successful transaction',
		learningGuidance: 'Learning guidance',
		orderDetails: 'Order details',
		orderTnformation: 'Order information',
		payment: 'Payment',
		orderNumber: 'Order number',
		paymentTime: 'Payment time',
		clientInformation: 'Client information',
		name: 'Name',
		phoneNumber: 'Phone number',
		refund: 'Refund',
		refundDetails: 'Refund details',
		refundTime: 'Refund application time',
		requestAmount: 'Request amount',
		refundAmount: 'Refund amount',
		rejectTime: 'Refund/reject time',
		refundRreason: 'Refund reason',
		rejectReason: 'Reject reason',
		submitSuccessfully: 'Submit successfully',
		meetingTarget: 'Meeting target',
		refunding: 'Refunding',
		refundDeclined: 'Refund declined',
		refunded: 'refunded',
		groupBuys: 'Group buys'
	},
	evalTeaching: {
		jrbtjls: 'Set as least preferred teacher',
		ComprehensiveEvaluation: 'Comprehensive evaluation',
		zsph: 'Set my Preferences',
		mloveTeacher1: 'My Preference',
	},
	jfdh: {
		title1: 'Acquisition conditions',
		title2: 'Scholarship available',
		hit1: 'Complete the project',
		hit2: 'Set according to the theme',
		hit3: 'Daily attendance',
		hit4: 'You can get 1, 3 and 7 scholarships for 1, 3 and 7 consecutive days',
		hit5: 'Invite new users to login',
		hit6: '6',
		hit7: 'First-time login',
		hit8: '3',
		hit9: 'Compete with friends-winner',
		hit10: '0.1',
		hit11: 'Complete study plans',
		hit12: 'Based on plans',
		hit13: 'Gifts',
		hit14: 'Based on gifts',
		hit15: '(Gift from company, gift from purchase etc)',
		hit16: 'Points can only be obtained in Daily AI Drill',
		hit17: 'Ponits obtained from certain channels have an expiration date, please use them before they expire. For points that are about to expire, there is an expiration reminder on the current page, please check.'
	},
	onsite: {
		apptip: 'Please check in for your class on the Daily English Training app.',
		apptip1: 'Download the Daily English Training app and enjoy 7 days of free lessons for new users.',
		Download: 'Download',
		view: 'Browse',
		downloadTop: 'Download from the computer',
		nyscgkj: 'You have uploaded the courseware',
		ClasTime: 'Class Schedule：',
		SignInTime: 'The check-in time：',
		RemoteCheckIn: 'Offite Punch',
		viewImg: 'Check the Picture',
		SignInImg: 'Punch-in Picture：',
		absenceFromDuty: 'Absent',
		PhotoCheckIn: 'Photo punch-in',
		SignInImmediately: 'Punch-in Now',
		Signed: 'Already punched in',
		Ended: 'Finished',
		Successfully: 'Punch-in successful',
		signInNOtip: 'Unable to check-in now.',
		close: 'Close',
		handTip: 'Please manually enable location permission',
		back: 'Back',
		tip: 'reminder',
		jsOpenPostionTop: 'Have you enabled location permission?',
		yes: 'Yes',
		no: 'No',
		signIn: 'Punch In',
		RepeatedClockIn: 'Cannot check-in repeatedly.',
		PositionQX: 'Please enable location permission.',
		CameraQX: 'Please enable camera permission.',
		classroomArea: 'You are not within the valid area for the class. Are you sure you want to punch in?',
		courseFeedbackTitle1: 'Mid-term Course Feedback',
		courseFeedbackTitle2: 'Graduation course feedback',
		courseFeedbackProblem1: 'Overall satisfaction with the learning content of this course.',
		courseFeedbackProblem01: 'Overall satisfaction with the learning content of this course.',
		courseFeedbackProblem2: 'Satisfaction with the teaching style of the course instructor in this session.',
		courseFeedbackProblem02: 'Satisfaction with the teaching style of the course instructor in this session.',
		courseFeedbackProblem3: 'Overall satisfaction with the course instructor.',
		courseFeedbackProblem03: 'Overall satisfaction with the course instructor.',
		courseFeedbackProblem4: 'Overall satisfaction with the training mode of this course.',
		courseFeedbackProblem04: 'Overall satisfaction with the training mode of this course.',
		courseFeedbackProblem5: 'Satisfaction with the duration of this course.',
		courseFeedbackProblem05: 'Satisfaction with the duration of this course.',
		courseFeedbackProblem6: 'Satisfaction with the training effectiveness of this course.',
		courseFeedbackProblem06: 'Satisfaction with the training effectiveness of this course.',
		courseFeedbackProblem7: 'How much did this training session help improve your English listening and speaking abilities?',
		courseFeedbackProblem07: 'How much did this training session help improve your English listening and speaking abilities?',
		courseFeedbackProblem8: 'What specific areas of content would you like to continue learning?',
		courseFeedbackProblem9: 'Please share your feedback, course takeaways, or learning experiences here.',
		ProblemSuccessTip: 'Submission successful. Thank you for your evaluation.',
		Enter: 'Please enter'
	},
	newFeedBack: {
		feedbackTip: 'Has the problem you feedback been solved?',
		HistoricalFeedback: 'Historical feedback',
		feedbackQues1: 'Have you installed the Daily Language Learning App and know how to find your courses?',
		feedbackQues01: 'Have you understood the learning process and objectives and started formal learning?',
		feedbackQues2: 'Have you added the WeChat account of your academic advisor and received guidance from them?',
		feedbackQues02: 'Have you adapted to the learning mode and the teaching style of your instructors?',
		feedbackQues3: 'Do you have any other unclear areas or difficulties during the learning process?',
		feedbackQues4: 'Have you adapted to your current course of study?',
		Comment: 'Comment',
		resolved: 'Yes',
		isResolved: 'Are you sure your feedback is unresolved?',
		yes: 'Yes',
		no: 'No',
		nos: 'No',
		has: 'Yes',
		NotSuitable: 'Not fully understood yet',
		Adaptation: 'Not quite adapted yet',
		SubmittedTip: 'Submit successfully, get 20 scholarships!',
		SubsequentFeedback: 'Feedback processing survey',
		Survey: 'Survey',
		Survey1: 'Survey',
		QuestionnaireSurvey: 'Questionnaire survey',
		feedbackDialogTitle1: 'Questionnaire Survey',
		feedbackDialogTitle2: 'Feedback Processing Survey',
		feedbackDialogText1: 'Welcome to our Business Training! In order to continuously improve our services and provide a better learning experience, please take 20 seconds to fill out the relevant course questionnaire. Thank you very much for your support.',
		feedbackDialogText2: 'Your feedback has been received, we have informed the relevant personnel to contact you, please take 10 seconds to fill in the questionnaire to confirm whether your feedback has been resolved.',
		later1: 'Fill in later',
		later2: 'Confirm later',
		Now1: 'Now',
		Now2: 'Now',
		Enter: 'Please enter',
		checkTip: 'Please fill out the questionnaire',
		questionnaireExpired:'The questionnaire has expired.'
	},
	newCenter: {
		cx: 'Learning',
		xz: 'Download',
		Follow: 'Follow',
		Setting: 'Setting',
		Exit: 'Exit',
		logoutConfirm: 'Are you sure you want to log out?',
		tips: 'Tips',
		confirm: 'Confirm',
		xzts: 'Install the Daily Education App',
		gzts: 'Follow Daily Education Official Account',
		ActivateStudyPass:"Activate Study Pass",
		RenewStudyPass:"Renew Study Pass",
		Remaining: "Remaining",
		Days: 'Days',
		jxj: 'Scholarship',
		ttlxf: 'Points',
		yhj: 'Coupons',
		zw: 'N/A',
		gdcj: 'More achievements',
		gmcxk: 'Buy Study Pass',
		zktq: 'Access all courses for free',
		myLesson: 'Completed Courses',
		xlyjs: 'Competition',
		ks: 'Exams',
		sc: 'Collections',
		yxls: 'Trainers',
		gj: 'Follow up',
		kcdd: 'Course orders',
		lljl: 'Browsing history',
		dcb: 'Word',
		dlzc: 'Login/Register',
	},
	newStudy: {
    expand: 'more',
    collapse: 'Collapse',
    KhExercise: 'Homework',
    canVideo: 'Watch video',
    zbdk: 'Cancel',
    ljqd: 'Book now',
    dingsj: 'Set a time',
    TeacherQA: 'Q&A',
    finalExam: 'Final exam',
    lszwkdzt: 'Teacher is unavailable',
    LabelNew: 'Tag',
    dqztygq: 'Current topic has expired',
    AvailableClasses: 'Available classes',
    Classover: 'Class is over',
    fxzhyyqgk: 'Share with wechat friends to watch together ',
    zawndkdkym: 'Opening the booking page for you',
    nhmyxydlso: "You don't have a preferred teacher yet",
    mqyxlswkdk:
      "There is no available class time for this preferred teacher, you can choose another preferred teacher's class time   ",
    qtx: 'Please fill in',
    xsrwwjk: 'Reward task questionnaires',

    HelloStudent: 'Hello, student!',
    guidelinesTip:
      'Please complete the entrance test first according to the guidelines.',
    StartStudy: 'Start your course study!',
    CompleteLater: 'Complete Later',
    CompleteEntranceTest: 'Complete Entrance Test',
    WelcomeToCenter: 'Hi～ Welcome to the Course Center',
    CourseCenter: 'Course Center',
    YourCurrentLevel: 'Your Current Level',
    TaketheTest: 'Take the Test',
    EntertheClassroom: 'Enter the classroom',
    Progress: 'Progress',
    PendingTasks: 'Pending Tasks',
    ForeignTeacherSalonClass: 'Foreign Teacher Salon Class',
    StartingSoon: 'Starting Soon',
    LimitedQuotas: 'Limited Quotas',
    MoreRecommendedCourses: 'Recommended Courses',
    LearningPerformance: 'Learning Performance',
    Settings: 'Settings',
    StylePreferences: 'Style',
    PreferencesT1: 'How fast do you want the teacher to speak?',
    Normalspeed: 'Normal speed',
    Slowerspeed: 'Slower speed',
    PreferencesT2:
      'How strict do you want the teacher to be in correcting you?',
    TimelyCorrections: 'Timely Corrections',
    DelayCorrections: 'Delay Corrections',
    PreferencesT3:
      'Do you want the teacher to chat with you at the beginning of the class?',
    Yes: 'Yes',
    No: 'No',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    PreferredTeachers: 'Teachers',
    PreferredTeachers11: 'Preferred Teacher',
    PreferredTeachersIip:
      'Choose Your Preferred teachers in After-class Evaluation',
    PreferredTimeSlots: 'Preferred Time',
    Choose: 'Choose',
    PreferredTimeEdit: 'Change Preferred Time Slots',
    Morning: 'Morning',
    Afternoon: 'Afternoon',
    Evening: 'Evening',
    Monday: 'Mon.',
    Tuesday: 'Tue.',
    Wednesday: 'Wed.',
    Thursday: 'Thu.',
    Friday: 'Fri.',
    Saturday: 'Sat.',
    Sunday: 'Sun.',
    PreferredTimeTip: 'Choose Preferred Time Slots for Later Booking',
    EarnedCredits: 'Earned Credits',
    CurrentLevel: 'Current Level',
    UpgradeTest: 'Upgrade',
    CompletedClass: 'Completed Class',
    StartClass: 'Start Class',
    BookClass: 'Book a Class',
    lbBookClass: 'Book a class',
    liveBroadcast: 'Live',
    min: 'min',
    hksc: 'class duration',
    HelpCenter: 'Help Center',
    mybookclass: 'Book a Class',
    Askleave: 'Ask for a leave',
    MakeupLessons: 'Make up Lessons',
    OtherHelp: 'Other Help',
    DetailedCreditSummary: 'Detailed Credit Summary',
    kqdx: 'Pre-class Preview',
    Vocabulary: 'Vocabulary',
    gdj: 'Follow-up Reading',
    points: 'points',
    Learned: 'Learned',
    View: 'View',
    EnterClassroom: 'Start',
    Currentlycompletedcourses: 'Currently completed courses',
    Availablecoursebookings: 'Available courses',
    Numberofabsences: 'Number of absences',
    IGotit: 'I Got it',
    CancelTopic: 'Cancel',
    EarnedCredits1: 'Earned Credits',
    Video: 'Video',
    videoTip: 'Watching videos makes English learning easier!',
    Vocabularys: 'Vocabulary',
    VocabularysTip:
      'Success is the sum of small efforts repeated day in and day out.',
    KnowledgePoint: 'Knowledge Point',
    KnowledgePointTip: 'Knowledge point is crucial for learning.',
    gdlx: 'Follow reading exercise',
    tzts: 'Expand and improve',
    FolloUp: 'Key sentence',
    FolloUpTip: "You're almost there! Keep up the good work!",
    LiveClassroom: 'Live Classroom',
    ClassTime: 'Class Time',
    CheckMaterials: 'Check Out',
    ChangeTime: 'Change',
    RemainingTimes: 'Remaining Times',
    AfterEvaluation: 'After-class Evaluation',
    CheckEvaluation: 'Check reviews',
    EvaluateTeacher: 'Evaluate',
    cancelTopicTip: 'You want to cancel this topic?',
    KnowledgePointLearning: 'Knowledge point',
    recordingTip: 'Tap the ripple to end recording',
    Complete: 'Done',
    LearnedVocabulary: 'Vocabulary',
    words: 'words',
    EarnedCredits: 'Credits',
    credits: 'credits',
    Relearn: 'Relearn',
    KeyPointLearning: 'Continue',
    wordContinue: 'Continue',
    FolloUpContinue: 'Continue',
    examsContinue: 'Continue',
    Catalogue: 'Catalogue',
    studyKnowledge: 'You have learned',
    seconds: 'seconds',
    secondsmin: 's',
    VocabularyPractice: 'Vocabulary Practice',
    AnswerAnalysis: 'Answer Analysis',
    Wronganswer: 'Wrong answer! Please reselect the correct answer!',
    Example: 'Example',
    studyTip01:
      'Please complete the preview of this lesson before class. This can help you better understand the content of this lesson. Completing the preview can also earn you credits and increase your learning level.',
    studyTip02:
      'If you cannot attend class on time, click "Change Time" (It will not change the class topic or teacher).',
    studyTip03:
      'If you want to change the topic, click "Cancel Topic" to cancel the current topic (Your preview records will be retained).',
    studyTip04: 'Keep studying for a bit longer!',
    NoRemind: 'No Longer Remind.',
    StudyLater: 'Study Later',
    ContinueStudying: 'Continue Studying',
    Teaching: 'Teaching',
    studyTip05:
      'The class is over. Are you satisfied with this class? Please leave your valuable suggestions.',
    studyTip06:
      'If you like the teacher, you can set him/her as your preferred teacher for future bookings.',
    BackCourse: 'Back',
    CompleteEvaluation: 'Complete',
    Replay: 'Replay',
    CompleteLearning: 'Complete Learning',
    studyTip07: 'Keep studying for a bit longer!',
    StudyLater: 'Study Later',
    ContinueStudying: 'Continue Studying',
    studyTip08: 'The teacher is absent. Please contact for assistance.',
    studyTip09:
      'Set the preferred time slot before booking, and the system will prioritize recommending courses that fit your preferred time.',
    ChoosePreferredTime: 'Choose Preferred Time Slots',
    ChoosePreferredTimeClick: 'Tap to Choose Preferred Time Slots',
    ChoosePreferredTimeTip: 'You can choose multiple preferred time slots.',
    Back: 'Back',
    ConfirmXZ: 'Confirm',
    SelectTopic: 'Select the Topic You Like',
    PreferredTimeSlots: 'Preferred Time',

    PreferredTimeSlotsTip:
      'No topics within the preferred time slots. Please select another topic.',
    PreferredTeacher: 'Preferred Teacher',
    PreferredTeacherTip:
      'No available teachers for the selected topic. Please select another topic.',
    PreferredTimeSlotsTip02:
      'Select the tags you are interested in. After selection, topics corresponding to these tags will be displayed first.',
    Today: 'Today',
    Tomorrow: 'Tomorrow',
    DonSelect: "Don't Select Now",
    ConfirmSelection: 'Confirm',
    OverallRating: 'Overall Rating',
    AudioSupport: 'Audio Support',
    Seriousminded: 'Serious-minded',
    PatientFriendly: 'Patient and Friendly',
    XiaozhiTip01: 'Xiaozhi is helping you filter the courses.',
    XiaozhiTip02:
      'More communication with the teacher can help you to achieve the best learning effect.',
    NeoCredits: 'Neo Credits',
    ClassSessions: 'Class Sessions',
    LearningLevel: 'Learning Level',
    NeoAccount: 'Account',
    Password: 'Password',
    Copy: 'Copy',
    OpenNeoApp: 'Open Neo App',
    Rebook: 'Rebook',
    QuickBooking: 'Quick Class Booking',
    neoStudyTip01:
      'Please download the Neo Study App before officially starting Neo courses.',
    neoStudyTip02: 'Please download Neo App first!',
    NotLearning: 'Not Learning Now',
    DownloadNow: 'Download Now',
    CreditsDetails: 'Credits Details',
    TargetCredits: 'Target Credits',
    TargetCreditsTip:
      "Target credits are the company's standards for individual project achievement",
    CurrentLearningLevel: 'Current Learning Level',
    CompletedLevel: 'Completed Level',
    BookAnyway: 'Book Anyway',
    PreviewFirst: 'Preview First',
    TargetLevel: 'Target',
    cueLevel: 'Current',
    LearningProgress: 'Learning Progress',
    SchedulingTip: 'Scheduling in progress, please wait',
    SchedulingTip02: 'List your preferred class times',
    SchedulingTip03:
      "We'll schedule classes that better suit your expectations",
    SelectTimeTp01: 'Up to 3 preferred times can be selected',
    SelectTimeTp04:
      'Note: Selected preferred times will be considered during scheduling.',
    SelectTimeTp02: 'Teacher has sent you class times',
    ViewIntroduction: 'View Introduction',
    ContactTeacher: 'Contact',
    DedicatedCoordinator: 'Coordinator',
    ContactCoordinator: 'Contact',
    AllSessions: 'All',
    Unattended: 'Unattended',
    Evaluated: 'Unevaluated',
    Completed: 'Done',
    Absent: 'Absent',
    AbsentTip01: 'No classes currently in session, no need to request leave. ',
    AbsentTip02: 'Please select the class you want to request leave for',
    AbsentTip03: 'Please select the class you want to make up',
    SelectTimeTp03:
      'Preferred times selected, scheduling will consider your preferences.',
    WatchTheVideo: 'Watch the video',

    qgjzd: 'Please follow the instructions to start learning!',
    YourTestLevel: 'Your Test Level',
    LastTestLevel: 'Last Test Level',
    days: 'd',
    hours: 'h',
    minutes: 'mins',
    ClassBegin: 'Class Begin!',
    TestBegin: 'Test Begin!',
    kyyyks: 'Time to book the test!',
    rklsyts: 'Teacher has sent you the time!',
    xzsksj: 'Pick the time',
    Scheduling: 'Scheduling',
    Registered: 'Registered',
    xtjcdnyycqkjl: 'One class absent',
    RedeemLater: 'Redeem Later',
    RedeemNow: 'Redeem Now',
    dqkyjxjbz:
      'Currently available scholarships are insufficient. Will the remaining amount be paid?',
    bkcgh: 'Makeup successfully. Earned 1 extra course selection!',
    NoMoreReminders: 'No More Reminders',
    jfqrzfcg: 'Confirm whether the payment is successful',
    ksysx: 'Test is invalid',
    qwcrxcs: 'Placement Test',
    wcrxcsh: 'The system will arrange the topic after placement test.',
    CompleteLater: 'Complete Later',
    ToComplete: 'To Complete',
    bkcgbg: 'No more than 8',
    CertificationTest: 'Test',
    GoToPreview: 'Preview',
    SuggestedCredits: 'Suggested Credits',
    NeoCredits: 'Neo Credits',
    VocabularyList: 'Vocabulary',
    kqlx: 'Pre-class Exercises',
    dzdlxkyqhxxdmr: 'Doing more exercises can reinforce what you have learned.',
    Uploadfiles: 'Upload files',
    scxyxxdnr:
      'Upload the learning content, and the teacher will instruct it in class',
    Uploadfiles1: 'Upload files',
    ReUpload: 'Re-upload',
    Viewfiles: 'View files',
    Teacher: 'Teacher',
    ClassReview: 'Class Review',
    khzy: 'After-class Exercises',
    khlx: 'After-class Exercises',
    wclxggxxjg: 'Complete the exercises to consolidate knowledge',
    ViewReviews: 'View Reviews',
    EvaluateTeacher: 'Evaluate',
    TeacherFeedback: 'Feedback',
    skqqwckxyxmr:
      'Complete the preview content, and you can get credits and promote the level',
    djqxjkxzqxyt: 'Click Cancel to cancel the topic or change the class time',
    Cancelss: 'Cancel',
    KeepRecord: 'Keep Record',
    jghsksj: 'Change the time',
    SuccessfullyUpload: 'Successfully Upload!',
    bnghsj: 'Time cannot be changed',
    qrqxdqks: 'Confirm cancel current class',
    cancelledSuccessfully: 'cancelled successfully',
    zxrw: 'Self-learning tasks',
    CreditsEarned: 'Credits Earned',
    PastLevel: 'Past Level',
    yhdxfmx: 'Earned Credit Details',
    jyneoxf: 'Suggested NEO Credits',
    Absent2: 'Absent',
    Absent3: 'Absent',
    dqksjbymbjbbf:
      'Current class level does not match the target level. Learning progress cannot be accumulated.',
    PreviewProcess: 'Preview Process',
    ClassesAttended: 'Classes attended',
    yjyggrnwc: 'Completed within one',
    Teacher1: 'Teacher',
    Evaluate1: 'Evaluate',
    bjClick: 'Make-up lessons',
    zwxfsj: 'No credit data available',
    qxzxydcz: 'Please select the operation',
    xzphsjh: 'After selecting the preferred time',
    pkshcknsxdsj: 'Classes will be scheduled based on the time you choose.',
    szphsj: 'Set preference time',
    SelectTime1: 'Select time',
    TimeRepeated: 'Time repeated',
    cbkcyl: 'Replay course preview',
    Teacher2: 'Teacher:',
    Play: 'Play',
    SupportVideoClasses: 'Video Support',
    SupportAudioClasses: 'Audio Support',
    ChineseTeachers: 'Chinese Teacher',
    ForeignTeachers: 'Foreign Teacher',
    ydyrs: 'Number of subscribers:',
    qxzsj: 'Please select time',
    Confirm2: 'Confirm',
    jzxzsj: 'Cannot select a period within 24 hours',
    qjcg: 'Successfully asked for leave',
    cklsxq: "Teacher's details",
    swyx: 'Set as preferred',
    qxxz: 'Deselect',
    zbxz: 'Select Later',
    wdyxls: 'My Preferred Teacher',
    dkcg: 'Book Successfully',
    sjggcg: 'Time change successful',
    qxzls: 'Please select a teacher',
    Return2: 'Return',
    dkywckyksbkdyx:
      'Booking completed. You can start the preview of this course.',
    dkywcqzzsskqqb:
      'Booking completed. Please ensure that the Neo Study credits have been obtained before the class.',
    zdnxxxdzt: 'Choose the topic',
    CurrentTopicLevel: 'Current Topic Level',
    xzdbjhbzd:
      'Selected label will be placed at the top. Select up to 5 labels.',
    yxsjnwkxzt: 'No topics are available during the preferred period.',
    wyxlskdyj: 'Preferred teacher cannot take this topic',
    zdkxzwg: 'Choose up to five',
    gjhxddygjawx:
      'The first lesson under this plan has not been studied. Please study the first lesson.',
    SingleChoice: 'Single Choice',
    NotCompleted: 'Not completed',
    Exit1: 'Exit?',
    StillExit: 'Still Exit',
    Continue11: 'Continue',
    TopicName: 'Topic Name',
    srscxdzm: 'Enter the subtitle you want to query',
    Speed: 'Speed',
    StusyLater: 'Study Later',
    Continue22: 'Continue',
    sjywc: 'The video is over.',
    Replay: 'Replay',
    Completed11: 'Completed',
    spjzcw: 'Video loading error.',
    scbfwcqwftz:
      'Cannot drag and drop the progress bar until the first play is complete.',
    scbfwcqwfsy:
      'This function cannot be used until the first playback is complete.',
    zxtcjblndlxjl: 'Quitting now will preserve your record.',
    dqjzmyyp: 'This sentence has no audio.',
    myzdly: 'No recording found',
    qxgbdqbfyp: 'Please close the currently playing audio first.',
    ycxwxggh: 'It is better to learn all at once!  Go for it !',
    ycwddcbkyc: 'Removed from my word list',
    DailySentence: 'Daily Sentence',
    dqysk: 'Currently in class',
    dqneoxf: 'NEO available courses',
    xxdfmmkzj:
      'Each Neo study score of 3000 points can increase the number of classes booked.',
    dkcghdkcs:
      'After successful booking, the number of available courses is reduced by one.',
    djzlkjrksym:
      'Click here to go to the class page, and view the learning content.',
    djqylzjjr:
      'Click to preview, and directly enter the unfinished preview step.',
    lcnxyskdsj: 'List of the time you would like to attend class',
    wmpkjgfhndyq: 'Our schedule will be more in line with your expectations.',
    Skip: 'Skip',
    ChooseTime: 'Choose Time',
    CannotCancel: 'Cannot Cancel',
    ndqwxbk: "You don't have to take any make-up lessons at the moment.",
    jfljdhbkq: 'Whether to redeem the coupon immediately?',
    wlyghdskty:
      'In order to have a better class experience, please set your class style preference.',
    dqmyydydk:
      'There are currently no booked classes, no need to ask for leave.',
    zxcs: 'Self-study',
    zycs: 'Exercises',
    xxzdsxhsndzt: 'XiaoZhi is selecting the right topic for you.',
    TestLevel: 'Test Level',
    EvaluationTip: 'Evaluation is the most authentic feedback～',
    Scholarship: 'Scholarship',
    CancelTip: 'Cancel?',
    AllReviews: 'All Reviews',
    Bookings: 'Bookings',
    ReadMore: 'Read More',
    Times: 'Times',
    salonJxjbz:
      'Currently available scholarships are insufficient. Will the remaining amount be paid?',
    LearnedBefore: 'Learned Before',
    booked: 'booked',
    Checktimetable: 'Check timetable',
    Zh: 'Zh',
    En: 'En',
    off: 'off',
    kczqpj: 'Midterm evaluation',
    lsVideo: 'Video',
    Preferred: 'Preferred',
    Americanaccent: 'American accent',
    Britishaccent: 'British accent',
    Neutralaccent: 'Neutral accent',
    American: 'British',
    British: 'British',
    Neutral: 'Neutral'
  },

	..._enLocale
}


// WEBPACK FOOTER //
// ./src/lang/en.js